import { z } from 'zod';
import { templateAdvanceLogicV1Schema } from './advance-logic';
import { templateNamedWidgetSchema } from './base';
import { fieldLayoutShape } from './field-layout';
import {
  noteSettingSchema,
  noteValueSchema,
  templateOptionsV1Schema,
} from './options';
import { templateParameterV1Schema } from './parameter';
import { templateReferenceV1Schema } from './reference';
import { TEXT_COLOR_VALUES, templateTextColorSchema } from './typography';

export const templateRadioSchema = templateNamedWidgetSchema.extend({
  type: z.literal('radio'),
  isRequired: z.boolean(),
  labelColor: templateTextColorSchema.default(TEXT_COLOR_VALUES.BLACK),
  options: templateOptionsV1Schema,
  parameter: templateParameterV1Schema.optional(),
  value: z.string(),
  note: noteValueSchema,
  noteSettings: z.array(noteSettingSchema).default([]),
  optionLayout: z.enum(['horizontal', 'vertical']).default('horizontal'),
  ...fieldLayoutShape,
  advanceLogics: templateAdvanceLogicV1Schema,
  reference: templateReferenceV1Schema,
});

export type TemplateRadioV1 = z.infer<typeof templateRadioSchema>;
